import TheoPlayerInterceptor from './TheoPlayerInterceptor';
export default class Interceptors {
    constructor(cdnBalancer) {
        this._cdnBalancer = cdnBalancer;
    }
    loadInterceptor(name, player) {
        if (name.toLowerCase() === 'theoplayer') {
            let interceptor = new TheoPlayerInterceptor(player, this._cdnBalancer);
            interceptor.load();
        }
    }
}
